import { IPayments } from '@vfit/consumer/data-access';

export const organizePaymentMethod = (dataFromCms: IPayments) => ({
  title: dataFromCms?.paymentsmobile?.title || '',
  subtitle: dataFromCms?.paymentsmobile?.userRegistered?.description || '',
  buttonLabel: dataFromCms?.paymentsmobile?.userRegistered?.changeLabel || '',
  yourIbanTitle: dataFromCms?.paymentsmobile?.paymentMethod?.titleIban || '',
  yourCreditCardTitle: dataFromCms?.paymentsmobile?.paymentMethod?.titleCard || '',
  yourDebitCardTitle:
    dataFromCms?.paymentsmobile?.paymentMethod?.titleDebitCard || 'La tua carta di debito',
  yourPrepaidCardTitle:
    dataFromCms?.paymentsmobile?.paymentMethod?.titlePrepaidCard || 'La tua carta prepagata',
  yourPaypalTitle:
    dataFromCms?.paymentsmobile?.paymentMethod?.titlePaypal || 'Il tuo account Paypal',
  expirationLabelTitle: dataFromCms?.paymentsmobile?.paymentMethod?.expirationLabel || '',
});

export const organizePaymentMethodError = (paymentCMS: IPayments) => ({
  titlePaymentError: paymentCMS?.paymentsmobile?.paymentSelectionError?.title || '',
  messagePaymentError: paymentCMS?.paymentsmobile?.paymentSelectionError?.description || '',
  actionLabel: paymentCMS?.paymentsmobile?.paymentSelectionError?.buttonLabel || '',
  messageSelectedPaymentError:
    paymentCMS?.paymentsmobile?.paymentError?.notFound?.message ||
    '',
  titleSelectedPaymentError: paymentCMS?.paymentsmobile?.paymentError?.notFound?.title || '',
});
